const dict = {
  chooseLang: "Επιλογή γλώσσας",
  agree: "Συμφωνώ",

  //Licence
  instructions: "Οδηγίες",
  step1: "Βήμα 1: Σαρώστε τον κωδικό QR",
  locateqr: "Εντοπίστε τον κωδικό QR στα δεξιά σας.",
  useSmartphone:
    "Χρησιμοποιήστε την κάμερα του smartphone σας ή μια εφαρμογή σάρωσης QR για να τον σαρώσετε. Αυτό θα σας οδηγήσει στο επόμενο βήμα.",
  step2: "Βήμα 2: Εισαγάγετε πληροφορίες λίστας αναπαραγωγής",
  afterScan: "Μετά τη σάρωση του κωδικού QR, θα σας ζητηθεί να εισαγάγετε τα στοιχεία της λίστας αναπαραγωγής σας.",
  makeSure: "Βεβαιωθείτε ότι έχετε συμπληρώσει όλα τα απαιτούμενα πεδία.",
  step3: "Βήμα 3: Επιστροφή στην εφαρμογή",
  onceYou:
    "Αφού εισαγάγετε τα στοιχεία της λίστας αναπαραγωγής σας, μπορείτε να επιστρέψετε στην εφαρμογή και να συνεχίσετε την εμπειρία σας.",
  refresh: "ΑΝΑΝΕΩΣΗ",
  playlist: "Λίστα αναπαραγωγής",
  bigPlaylist: "ΛΙΣΤΕΣ ΑΝΑΠΑΡΑΓΩΓΗΣ",
  noLicence: "Δεν έχετε άδεια χρήσης.",
  scanLicence: "Σαρώστε για αγορά άδειας.",
  noPlaylist: "Δεν έχετε καμία λίστα αναπαραγωγής",
  privacyBig: "ΛΕΙΤΟΥΡΓΙΑ ΑΠΟΡΡΗΤΟΥ",
  scanToAddBig: "ΣΑΡΩΣΤΕ ΓΙΑ ΠΡΟΣΘΗΚΗ ΛΙΣΤΑΣ",
  scanToBuyBig: "ΣΑΡΩΣΤΕ ΓΙΑ ΑΓΟΡΑ ΑΔΕΙΑΣ",
  orVisit: "ή επισκεφθείτε",
  andenterdeviceID: "και εισαγάγετε αυτό το αναγνωριστικό συσκευής:",
  removePlaylist: "Αφαίρεση λίστας αναπαραγωγής",
  wantToRemove: "Θέλετε να αφαιρέσετε;",
  cancelBig: "ΑΚΥΡΩΣΗ",
  loading: "Φόρτωση...",
  enablePMode: "Παρακαλώ ενεργοποιήστε τη Λειτουργία Απορρήτου για να συνεχίσετε την παρακολούθηση.",
  killSwitchProtecting: "Το Kill Switch προστατεύει το απόρρητό σας αποκλείοντας την πρόσβαση όταν η Λειτουργία Απορρήτου είναι απενεργοποιημένη.",
  kSwitchProtecionActive: "Η Προστασία Kill Switch είναι Ενεργή",
  privacyMode: "Λειτουργία Απορρήτου",
  ok: "ΟΚ",

  //Home
  bigLiveTv: "Ζωντανή Τηλεόραση",
  bigMovies: "Ταινίες",
  bigSeries: "Σειρές",
  //Channel-Menu
  noChannels: "Αυτή η λίστα αναπαραγωγής δεν έχει δεδομένα καναλιών",
  searchChannels: "Αναζήτηση καναλιού",
  tapToPlay: "Πατήστε για αναπαραγωγή της ροής βίντεο.",
  categoryEmpty: "Αυτή η κατηγορία είναι κενή",
  pinNotSet: "Το PIN δεν έχει οριστεί",
  setPinNow: " Θέλετε να ορίσετε το PIN σας τώρα;",
  preview: "ΠΡΟΕΠΙΣΚΟΠΗΣΗ",
  liveTv: "Ζωντανή Τηλεόραση",
  addToFav: "Προσθήκη στα Αγαπημένα",
  removeFromFav: "Αφαίρεση από τα Αγαπημένα",
  now: "Τώρα:",
  nextPlaying: "Επόμενο:",
  channels: "Κανάλια",
  noChannelsFound: "Δεν βρέθηκαν κανάλια",

  //Movies
  noMovies: "Αυτή η λίστα αναπαραγωγής δεν έχει δεδομένα ταινιών",
  searchMovies: "Αναζήτηση ταινιών",
  noFavMovies: "Δεν υπάρχουν αγαπημένες ταινίες",
  //series
  noSeries: "Αυτή η λίστα αναπαραγωγής δεν έχει δεδομένα σειρών",
  searchSeries: "Αναζήτηση σειρών",
  noFavSeries: "Δεν υπάρχουν αγαπημένες σειρές",
  search: " Αναζήτηση",
  thereIsProblem: "Υπάρχει πρόβλημα αυτή τη στιγμή",
  tryAgainLater: "Παρακαλώ δοκιμάστε ξανά αργότερα.",
  series: "Σειρές",
  movies: "Ταινίες",
  noSeriesFound: "Δεν βρέθηκαν σειρές",
  noMoviesFound: "Δεν βρέθηκαν ταινίες",
  //entity
  play: "ΑΝΑΠΑΡΑΓΩΓΗ",
  playMovie: "Αναπαραγωγή ταινίας",
  recommendations: "Προτάσεις",
  //User Info
  userInfo: "Πληροφορίες χρήστη",
  aboutApp: "Σχετικά με την εφαρμογή",
  //Userinfo
  account: "Λογαριασμός",
  subscriptions: "Συνδρομές",
  privacyPilicy: "Απόρρητο & Πολιτική",
  languge: "Γλώσσα",
  english: "Αγγλικά",
  italian: "Ιταλικά",
  german: "Γερμανικά",
  spanish: "Ισπανικά",
  french: "Γαλλικά",
  saudiArabia: "Αραβικά",
  chinese: "Κινέζικα",
  greek: "Ελληνικά",
  turkish: "Τουρκικά",
  change_pin: "Αλλαγή PIN",
  kill_switch: "Kill Switch",
  device_info: "Πληροφορίες συσκευής",
  unknown: "Άγνωστο",

  //headers
  settings: "Ρυθμίσεις",
  termsConditions: "Όροι & Προϋποθέσεις",
  home: "Αρχική",

  //license
  scanQrCode: "Σαρώστε τον κωδικό QR για αποστολή λίστας αναπαραγωγής",
  managePlaylist: "Διαχείριση λίστας αναπαραγωγής",
  orVisitt: "Ή επισκεφθείτε",
  scanToAdd: "Σαρώστε για προσθήκη λίστας αναπαραγωγής ή επισκεφθείτε",

  //device info
  display: "Οθόνη",
  storage: "Αποθήκευση",
  network: "Δίκτυο",
  connection: "Σύνδεση",
  macAddress: "Διεύθυνση MAC:",
  deviceId: "Αναγνωριστικό συσκευής:",
  pmInfo: "Πληροφορίες Λειτουργίας Απορρήτου",
  statusActive: "Κατάσταση: Ενεργό",
  underMaintance: "Κατάσταση: Υπό Συντήρηση",
  version: "Έκδοση:",
  lastBuildDate: "Ημερομηνία τελευταίας κατασκευής:",
  lastUpdated: "Τελευταία ενημέρωση: ",

  //kill switch
  enableKillSwitch: "Ενεργοποίηση Kill Switch;",
  disableKillSwitch: "Απενεργοποίηση Kill Switch;",
  whenEnabled: "Όταν είναι ενεργοποιημένο, το OrbixPlay θα λειτουργεί ΜΟΝΟ όταν η Λειτουργία Απορρήτου είναι ενεργή.",
  withOrWithoutPM: "Το OrbixPlay θα λειτουργεί κανονικά με ή χωρίς Λειτουργία Απορρήτου.",
  extra_privacy_protection: " Επιπλέον Προστασία Απορρήτου",
  pmOn: "• Εάν η Λειτουργία Απορρήτου είναι ΕΝΕΡΓΗ: μπορείτε να μεταδίδετε περιεχόμενο με ασφάλεια",
  killSwitchDescription: "Το Kill Switch παρέχει ένα επιπλέον επίπεδο προστασίας για μέγιστο απόρρητο.",
  pmOff: "• Εάν η Λειτουργία Απορρήτου είναι ΑΝΕΝΕΡΓΗ: η εφαρμογή θα αποκλείσει την πρόσβαση για την προστασία του απορρήτου σας",
  reenable: "Μπορείτε να το ενεργοποιήσετε ξανά ανά πάσα στιγμή για μέγιστη ασφάλεια.",
  cancel: "Ακύρωση",
  enable: "Ενεργοποίηση",
  disable: "Απενεργοποίηση",
  killSwitch: "Kill Switch – Επιπλέον Προστασία Απορρήτου",
  ipHidden: "Όταν ενεργοποιείτε τη Λειτουργία Απορρήτου, η διεύθυνση IP σας αποκρύπτεται και η σύνδεσή σας διέρχεται από ένα ασφαλές σύστημα — παρόμοια με τον τρόπο λειτουργίας ενός VPN.",
  extraLayer: "Το Kill Switch είναι ένα επιπλέον επίπεδο προστασίας: εάν το ενεργοποιήσετε, το OrbixPlay θα λειτουργεί μόνο όταν η Λειτουργία Απορρήτου είναι ενεργή.",
  ifPmOn: "• Εάν η Λειτουργία Απορρήτου είναι ΕΝΕΡΓΗ: μπορείτε να μεταδίδετε περιεχόμενο με ασφάλεια",
  ifPmOff: "• Εάν η Λειτουργία Απορρήτου είναι ΑΝΕΝΕΡΓΗ: η εφαρμογή θα αποκλείσει την πρόσβαση για την προστασία του απορρήτου σας",
  recommended: "Συνιστάται για όσους θέλουν μέγιστη ασφάλεια και δεν θέλουν ποτέ να μεταδίδουν χωρίς προστασία.",
  current_status: "Τρέχουσα κατάσταση:",
  pressToDisable: "🛡️ ΕΝΕΡΓΟΠΟΙΗΜΕΝΟ - Πατήστε για απενεργοποίηση",
  pressToEnable: "○ ΑΠΕΝΕΡΓΟΠΟΙΗΜΕΝΟ - Πατήστε για ενεργοποίηση",
  pressEnter: " Πατήστε Enter στο παραπάνω κουμπί για αλλαγή ρύθμισης Kill Switch",

  //set pin
  pinSetSuccessfully: "Το PIN ορίστηκε επιτυχώς!",
  createPin: "Δημιουργήστε το PIN σας",
  confirmPin: "Επιβεβαιώστε το PIN σας",
  confirmYourPin: "confirmPin: 'Επιβεβαιώστε το PIN σας'",
  initializingPin: "Αρχικοποίηση ρύθμισης PIN...",
  enterCurrentPin: "Εισαγάγετε το τρέχον PIN",
  enterNewPin: "Εισαγάγετε νέο PIN",
  confirmNewPin: "Επιβεβαιώστε το νέο PIN",
  pinChanged: "Το PIN άλλαξε επιτυχώς!",
  pinHasChanged: " Το PIN σας άλλαξε επιτυχώς!",

  //lastones
  playInfo: "Πληροφορίες λίστας αναπαραγωγής",
  playName: "Όνομα λίστας αναπαραγωγής:",
  host: "Κεντρικός υπολογιστής:",
  username: "Όνομα χρήστη:",
  password: "Κωδικός πρόσβασης:",
  packName: "Όνομα πακέτου:",
  expireDate: "Ημερομηνία λήξης:",

  //privacyPolicy
  one: "1. Αποποίηση ευθύνης περιεχομένου: Το OrbixPlay είναι μια πλατφόρμα σχεδιασμένη να βελτιώνει την ψηφιακή σας εμπειρία. Ωστόσο, είναι σημαντικό να σημειωθεί ότι το OrbixPlay δεν φιλοξενεί, παρέχει ή διανέμει βιντεοπεριεχόμενο. Η υπηρεσία μας είναι δομημένη για να υποστηρίζει το ψηφιακό σας ταξίδι, αλλά δεν φέρουμε ευθύνη για τη διαθεσιμότητα, την ποιότητα ή το περιεχόμενο βιντεοϋλικού, καθώς αυτό είναι εκτός του πεδίου εφαρμογής των υπηρεσιών μας.",
  two: "2. Καμία ευθύνη για περιεχόμενο τρίτων: Η OrbixPlay LLC δεν ευθύνεται για οποιοδήποτε περιεχόμενο τρίτων στο οποίο ενδέχεται να αποκτήσετε πρόσβαση μέσω της εφαρμογής μας. Η εμπλοκή σας με οποιοδήποτε εξωτερικό περιεχόμενο, συμπεριλαμβανομένης της νομιμότητας, αξιοπιστίας ή καταλληλότητάς του, γίνεται αποκλειστικά με δική σας ευθύνη.",
  three:
    "3. Δικαιοδοσία και Συμμόρφωση: Η OrbixPlay LLC λειτουργεί υπό τη δικαιοδοσία των Ηνωμένων Πολιτειών. Οι χρήστες είναι υπεύθυνοι για τη διασφάλιση ότι η χρήση της εφαρμογής συμμορφώνεται με όλους τους τοπικούς, πολιτειακούς και ομοσπονδιακούς νόμους.",
  four: "4. Πολιτική τιμολόγησης: Οι τιμές για τις υπηρεσίες του OrbixPlay υπόκεινται σε αλλαγές ανά πάσα στιγμή χωρίς προηγούμενη ειδοποίηση. Αποδεχόμενοι αυτή τη συμφωνία, αναγνωρίζετε και αποδέχεστε ότι οι τιμές ενδέχεται να διαφέρουν και ότι τέτοιες αλλαγές δεν θα επηρεάσουν την τρέχουσα υπηρεσία σας μέχρι την ανανέωση της συνδρομής σας.",
  five: `5. Καμία εγγύηση: Η εφαρμογή OrbixPlay και οι υπηρεσίες της παρέχονται «ως έχουν» χωρίς καμία ρητή ή σιωπηρή εγγύηση, συμπεριλαμβανομένων, ενδεικτικά, σιωπηρών εγγυήσεων εμπορευσιμότητας, καταλληλότητας για συγκεκριμένο σκοπό και μη παραβίασης.`,
  six: "6. Αποδοχή Όρων: Κάνοντας κλικ στο Αποδοχή, συμφωνείτε να δεσμεύεστε από τους όρους αυτής της αποποίησης και αναγνωρίζετε ότι οποιαδήποτε παραβίαση μπορεί να οδηγήσει σε τερματισμό της πρόσβασής σας στις υπηρεσίες OrbixPlay.",
  orbixUserAgreement: "ΣΥΜΦΩΝΙΑ ΧΡΗΣΤΗ ΚΑΙ ΑΠΟΠΟΙΗΣΗ ΕΥΘΥΝΗΣ ORBIXPLAY",
  beforeyouProcc: "Πριν προχωρήσετε, παρακαλώ διαβάστε και αποδεχθείτε τους παρακάτω όρους και προϋποθέσεις:",

  //additional
  exitApp: "Έξοδος από το OrbixPlay",
  wantToExit: "Είστε βέβαιοι ότι θέλετε να βγείτε από το OrbixPlay;",
  Resume: "Συνέχεια",

  whatsnewinv: "Τι νέο υπάρχει στην έκδοση v",
  whatsnew: "Τι νέο υπάρχει",

  resellerInfiniteDevices: "Πρόγραμμα Μεταπωλητή: Απεριόριστες Συσκευές",
  resellerInfiniteDevicesDesc: "Η ίδια λίστα αναπαραγωγής μπορεί πλέον να εγκατασταθεί σε απεριόριστες συσκευές — όχι 5 ή 10, αλλά όσες χρειάζεστε.",
  thankyouforusingorbixplayenjoythenewfeatures: "Ευχαριστούμε που χρησιμοποιείτε το OrbixPlay — απολαύστε τις νέες λειτουργίες!",

  instanthomescreen: "Συνέχιση παρακολούθησης",
  instanthomescreendesc: "Συνεχίστε τις σειρές και τις ταινίες σας από εκεί που σταματήσατε.",
  turbomoviesearch: "Λειτουργία Αγαπημένων",
  turbomoviesearchdesc: "Αποθηκεύστε το αγαπημένο σας περιεχόμενο για γρήγορη και εύκολη πρόσβαση ανά πάσα στιγμή.",
  lighterondataandbattery: "Βελτιωμένη Σταθερότητα Αναπαραγωγής",
  lighterondataandbatterydesc: "Βελτιωμένη αξιοπιστία αναπαραγωγής και πιο ομαλές λειτουργίες αναζήτησης.",
  underthehoodfixes: "Διορθώσεις στο Παρασκήνιο",
  underthehoodfixesdesc: "Διάφορες διορθώσεις σφαλμάτων και βελτιώσεις απόδοσης για καλύτερη εμπειρία.",

  proxyMaintenance: 'Συντήρηση Διακομιστή Μεσολάβησης',
  proxyMaintenanceMessage: 'Ο διακομιστής μεσολάβησης βρίσκεται αυτήν τη στιγμή υπό συντήρηση. Παρακαλώ δοκιμάστε ξανά αργότερα.',

  playlistInformation: 'Πληροφορίες Λίστας Αναπαραγωγής',
  playlistExpDate: 'Ημερομηνία λήξης λίστας αναπαραγωγής: ',

  select_playlist: "Επιλογή Λίστας Αναπαραγωγής",
  choose_playlist: "Επιλέξτε μια λίστα αναπαραγωγής για να ξεκινήσετε να παρακολουθείτε",
  invalid_line: "Μη Έγκυρη Γραμμή",
  expire_date: "Ημερομηνία Λήξης:",
  expired: "Έληξε",
  waiting_connection: "Αναμονή σύνδεσης...",
  reconnection_attempt: "Απόπειρα επανασύνδεσης",
  try_again: "Δοκιμάστε Ξανά",
  go_back: "Πίσω",
  unable_to_resume: "Αδύνατη η Συνέχιση",
  reconnecting: "Επανασύνδεση...",
  no_internet_connection: "Δεν Υπάρχει Σύνδεση στο Διαδίκτυο",
  please_try_again: "Δεν ήταν δυνατή η επανεκκίνηση της ροής. Δοκιμάστε ξανά.",
  restore_stream: "Παρακαλώ περιμένετε ενώ επαναφέρουμε τη ροή σας.",
  reconnect_automatically: "Ελέγξτε το δίκτυό σας και θα επανασυνδεθούμε αυτόματα.",
  check_wifi: "Ελέγξτε τη σύνδεση WiFi σας",
  check_ethernet: "Ελέγξτε τη σύνδεση Ethernet / LAN σας",
  check_internet: "Ελέγξτε τη σύνδεσή σας στο διαδίκτυο",

  add_playlist_screen: "Προσθήκη Λίστας",
  add_playlist: "Χειροκίνητη προσθήκη λίστας",
  playlist_name_required: "Απαιτείται όνομα λίστας",
  m3u_url_required: "Απαιτείται URL M3U λίστας",
  server_url_required: "Απαιτείται URL διακομιστή",
  username_required: "Απαιτείται όνομα χρήστη",
  password_required: "Απαιτείται κωδικός πρόσβασης",
  orbix_code_required: "Απαιτείται κωδικός κεντρικού υπολογιστή Orbix",
  list_code_required: "Απαιτείται κωδικός λίστας",
  device_id_required: "Απαιτείται ID συσκευής",
  device_id: "ID Συσκευής : ",
  playlist_format: "Μορφή Λίστας",
  m3u: "URL M3U",
  username_password: "Όνομα χρήστη / Κωδικός",
  orbix_code: "Κωδικός Orbix",
  list_code: "Κωδικός Λίστας",
  playListName: "Όνομα Λίστας *",
  m3uUrl: "URL Λίστας M3U *",
  server_URL: "URL Διακομιστή *",
  username_req: "Όνομα χρήστη *",
  password_req: "Κωδικός *",
  orbix_code_req: "Κωδικός κεντρικού υπολογιστή Orbix *",
  list_code_req: "Κωδικός Λίστας *",
  addPlaylist: "Προσθήκη Λίστας",
  adding: "Προσθήκη...",
  my_playlist: "Η Λίστα μου",
  username_placeholder: "όνομα χρήστη",
  password_placeholder: "••••••••",

  //stream exceptions
  stream_extension: "Επέκταση ροής",

  //storage_and_data
  storage_and_data: "Αποθήκευση & Δεδομένα",

  // ── Parental PIN ──────────────────────────────────────────────────────────
  enter_parental_pin: "Εισαγωγή γονικού PIN",

  // ── Account / Subscriptions labels ───────────────────────────────────────
  status: "Κατάσταση",
  active: "Ενεργό",
  expiration: "Λήξη",
  max_connections: "Μέγ. Συνδέσεις",
  one_device: "1 Συσκευή",
  created: "Δημιουργήθηκε",

  // ── Storage & Data screen ─────────────────────────────────────────────────
  section_title: "Αποθήκευση & Δεδομένα",
  section_subtitle: "Διαχείριση αποθηκευμένων δεδομένων εφαρμογής",
  favourites_label: "Αγαπημένα",
  history_label: "Ιστορικό παρακολούθησης",
  cleared_label: "Εκκαθαρίστηκε",
  all_cleared_label: "Όλα εκκαθαρίστηκαν",
  remove_cancel_label: "Ακύρωση",
  remove_confirm_label: "Εκκαθάριση",
  clear_fav_channels_title: "Αγαπημένα κανάλια",
  clear_fav_channels_subtitle: "Αφαίρεση όλων των αποθηκευμένων καναλιών",
  clear_fav_channels_message: "Εκκαθάριση όλων των αγαπημένων καναλιών;",
  clear_fav_movies_title: "Αγαπημένες ταινίες",
  clear_fav_movies_subtitle: "Αφαίρεση όλων των αποθηκευμένων ταινιών",
  clear_fav_movies_message: "Εκκαθάριση όλων των αγαπημένων ταινιών;",
  clear_fav_series_title: "Αγαπημένες σειρές",
  clear_fav_series_subtitle: "Αφαίρεση όλων των αποθηκευμένων σειρών",
  clear_fav_series_message: "Εκκαθάριση όλων των αγαπημένων σειρών;",
  clear_continue_watching_movies_title: "Συνέχεια παρακολούθησης – Ταινίες",
  clear_continue_watching_movies_subtitle: "Αφαίρεση προόδου παρακολούθησης ταινιών",
  clear_continue_watching_series_title: "Συνέχεια παρακολούθησης – Σειρές",
  clear_continue_watching_series_subtitle: "Αφαίρεση προόδου παρακολούθησης σειρών",
  clear_continue_watching_title: "Συνέχεια παρακολούθησης",
  clear_continue_watching_message: "Εκκαθάριση ιστορικού παρακολούθησης;",
  clear_all_title: "Εκκαθάριση όλων των δεδομένων",
  clear_all_message: "Αυτό θα εκκαθαρίσει όλα τα αγαπημένα και το ιστορικό.",

  // ── Stream Extension screen ───────────────────────────────────────────────
  stream_extension_desc: "Επιλέξτε πώς ζητούνται τα live streams από τον διακομιστή σας.",
  ts_desc: "Τυπική ροή MPEG-TS",
  m3u8_desc: "Προσαρμοστική ροή HLS",
  current: "Τρέχον",

  // ── Kill Switch modal ─────────────────────────────────────────────────────
  access_restricted: "🛡️ Πρόσβαση περιορισμένη",
  to_access_playlists: "Για πρόσβαση σε λίστες αναπαραγωγής:",
  enable_privacy_mode_step: "1. Ενεργοποιήστε τη Λειτουργία Απορρήτου από την κύρια οθόνη",
  disable_kill_switch_step: "2. Ή απενεργοποιήστε το Kill Switch στις Ρυθμίσεις → Kill Switch",
  preparingContent: "Προετοιμασία περιεχομένου",

  // ── Home screen ──────────────────────────────────────────────────────────────
  loading_base: "Φόρτωση",
  live_now: "ΖΩΝΤΑΝΑ ΤΩΡΑ",
  news: "ΕΙΔΗΣΕΙΣ",
  sport: "ΑΘΛΗΤΙΚΑ",
  kids: "ΠΑΙΔΙΑ",

  // ── Series details ───────────────────────────────────────────────────────────
  episode: "Επεισόδιο",
  no_episodes: "Δεν υπάρχουν διαθέσιμα επεισόδια για αυτή τη σεζόν.",

  searchForChannels: "Αναζήτηση καναλιών...",
  kbSpace: "Κενό",
  kbCaps: "Κεφαλαία",
  pressOkToPlay: "Πατήστε OK για αναπαραγωγή",
  live: "Ζωντανά",
};

export default dict;